import React, { FC, useCallback, useState } from "react";
import { ButtonProps, Dialog, Input } from "@xapp/components";

import { BasicIntegrationCard, IntegrationCardProp } from "./BasicIntegrationCard";

export interface FieldPulseConnectionProps {
    integration: "fieldpulse";
    token: string;
}

export interface FieldPulseIntegrationCardProps extends IntegrationCardProp {
    token?: string;

    onConnect?(props: FieldPulseConnectionProps): void;
}

export const FieldPulseIntegrationCard: FC<FieldPulseIntegrationCardProps> = (props) => {

    const { checked, disabled, isLinked, isActive, onConnect, onDisconnect } = props;

    const [token, setToken] = useState<string>(props.token || "");
    const [showDialog, setShowDialog] = useState<boolean>(false);

    const handleFieldPulseClick = (e: React.MouseEvent<HTMLAnchorElement>): void => {
        e.preventDefault();

        if (typeof checked === "boolean") {
            if (typeof props.onClick === "function") {
                props.onClick(e);
            }
        } else {
            // pop up modal
            setShowDialog(true);
        }
    };

    const handleConnectFieldPulse = useCallback(() => {
        if (typeof onConnect === "function") {
            onConnect({ integration: "fieldpulse", token });
            setShowDialog(false);
        }
    }, [onConnect, token]);

    const handleDisconnectFieldPulse = useCallback(() => {
        if (typeof onDisconnect === "function") {
            onDisconnect();
        }
    }, [onDisconnect]);

    const actions: ButtonProps[] = [
        {
            label: "Close",
            variation: "secondary",
            onClick: () => { setShowDialog(false) }
        }
    ];

    if (typeof onConnect === "function") {
        actions.push({
            label: "Connect",
            variation: "primary",
            disabled: !token,
            onClick: handleConnectFieldPulse
        })
    }

    return (
        <>
            <BasicIntegrationCard
                checked={checked}
                disabled={disabled}
                imageUrl="/img/integrations/field-pulse/fieldpulse-logo.png"
                integrationId="fieldpulse"
                text="FieldPulse"
                href={() => "/integrations/fieldpulse"}
                onClick={handleFieldPulseClick}
                isLinked={isLinked}
                isActive={isActive}
                onDisconnect={typeof onDisconnect === "function" ? handleDisconnectFieldPulse : undefined}
            />
            <Dialog
                active={showDialog}
                actions={actions}
                title="FieldPulse Setup"
                onClose={() => { setShowDialog(false) }}
            >
                <p>Paste your FieldPulse API key below.</p>
                {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                {/* @ts-ignore */}
                <Input label="FieldPulse API Key" value={token} onChange={setToken} />
                <p>More detailed instructions can be found <a target="_blank" href={"https://documentation.xapp.ai/help/integrations/integration-fieldpulse#connect-your-fieldpulse-account-to-xapp-ai"} rel="noreferrer">here</a></p>
            </Dialog>
        </>
    );
}